export default {
      id: "gift-entry-reverse-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#gift-entry-reverse",
      toString: function () {
        return this.url;
      }
    }